import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'

// key 列表：dmaker.custom.info,dmaker.custom.save

/**
 * getDmakerCustomInfo
 * @param {{id: number}} id
 */
export function getDmakerCustomInfo(params) {
  return request({
    url: `${v2Host}/dmaker/custom/info`,
    method: 'get',
    params,
  })
}

/**
 * 创意模板保存&打包
 * http://playable.dev.com:8067/?doc=dmaker/template.go#%2fdmaker%2ftemplate%2fsave
 * @param {{custom_id: number}} params
 * @param {{json_config?: string, category_config?: string, resource_config?: string, dco_config?: string, allow_add_language?: number, stars_config?: string, pack_json_config?: string, language: string}} data
 */
export function saveDmakerCustom(params, data, autoSave) {
  return request({
    url: `${v2Host}/dmaker/custom/save`,
    method: 'post',
    data,
    params,
    withoutError: autoSave,
  })
}

export function fetchCustomList(params) {
  return request({
    url: `${v2Host}/dmaker/custom/list`,
    method: 'GET',
    params: cookRequestParams(params),
  })
}

/**
 * 创意模板资源删除
 * @param {} data
 * http://playable.dev.com:8067/?doc=creative/custom.go
 */
export function deleteCreativeVersion(id, data) {
  return request({
    url: `${v2Host}/dmaker/custom/delete?custom_id=${id}`,
    method: 'post',
    data,
  })
}

/**
 * previewDmakerTemplate
 * http://playable.dev.com:8067/?doc=dmaker/template.go#%2fdmaker%2ftemplate%2finfo
 * @param {{id: number, lang: string}} params
 */
export function previewDmakerCustom(params, config) {
  return request({
    url: `${v2Host}/dmaker/custom/preview`,
    method: 'get',
    params,
    ...config,
  })
}

export function fetchTemplateChannelList(params) {
  return request({
    url: `${v2Host}/dmaker/template/channel-list`,
    method: 'get',
    params,
  })
}

export function fetchVersionChannelList(params) {
  return request({
    url: `${v2Host}/dmaker/custom/channel-list`,
    method: 'get',
    params,
  })
}

export function fetchVersionDownloadStatus(params) {
  return request({
    url: `${v2Host}/dmaker/custom/download-check`,
    method: 'get',
    params,
  })
}

export function publishCustom(data) {
  return request({
    url: `${v2Host}/dmaker/custom/publish`,
    method: 'post',
    data,
  })
}

export function updateTemplateCoverInfo(data) {
  return request({
    url: `${v2Host}/dmaker/template/update-info`,
    method: 'post',
    data,
  })
}

export function fetchVersionDownloadResource(params) {
  return request({
    url: `${v2Host}/dmaker/custom/download-resource`,
    method: 'get',
    params,
  })
}

// 定制制作素材下载接口
export function downloadCustomPlayable(params) {
  return request({
    url: `${v2Host}/dmaker/custom/download`,
    method: 'get',
    params,
  })
}

export function getDmakerCopyLink(params) {
  return request({
    url: `${v2Host}/dmaker/custom/copy-links`,
    method: 'get',
    params,
  })
}
